import React, { useCallback, useMemo, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Include the Quill styles

const MAX_IMAGE_SIZE = 259900; // 259.9KB

const MyEditor = (props) => {
    const quillRef = useRef(null);
    const [imageError, setImageError] = useState('');

    const imageHandler = useCallback(() => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();
        input.onchange = () => {
            const file = input.files[0];
            if (!file) return;
// if (file.size > MAX_IMAGE_SIZE) {
            //     setImageError("L'immagine supera il limite massimo di 259.9KB e non può essere inserita.");
            //     return;
            // }
            setImageError('');
            const reader = new FileReader();
            reader.onload = (e) => {
                const quill = quillRef.current.getEditor();
                const range = quill.getSelection(true);
                quill.insertEmbed(range.index, 'image', e.target.result);
            };
            reader.readAsDataURL(file);
        };
    }, []);

    const modules = useMemo(() => ({
        toolbar: {
            container: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['link', 'image'],
            [{'color': []}, {'background': []}],
            ['clean'],
        ],
            handlers: { image: imageHandler },
        },
    }), [imageHandler]);

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet',
        'link', 'image',
        'color', 'background',
    ];

    return (
        <div>
            <ReactQuill
                ref={quillRef}
                theme="snow"
                value={props.editorHtml}
                onChange={props.setEditorHtml}
                modules={modules}
                formats={formats}
            />
        </div>
    );
};

export default MyEditor;